import * as easingPatterns from "./easing-patterns";

const defaults = {
  container:
    document.scrollingElement || document.body || document.documentElement,
  duration: 500,
  offset: 0,
  easing: "easeInOutCubic"
};

function getOffset(target) {
  if (typeof target === "number") {
    return target;
  }

  let el = $(target);
  if (!el) {
    throw typeof target === "string"
      ? new Error(`Target element "${target}" not found.`)
      : new TypeError(
          `Target must be a Number/Selector/HTMLElement/VueComponent, received ${type(
            target
          )} instead.`
        );
  }

  let totalOffset = 0;
  while (el) {
    totalOffset += el.offsetTop;
    el = el.offsetParent;
  }

  return totalOffset;
}

function getContainer(container) {
  const el = $(container);

  if (el) return el;

  throw typeof container === "string"
    ? new Error(`Container element "${container}" not found.`)
    : new TypeError(
        `Container must be a Selector/HTMLElement/VueComponent, received ${type(
          container
        )} instead.`
      );
}

function type(el) {
  return el == null ? el : el.constructor.name;
}

function $(el) {
  if (typeof el === "string") {
    return document.querySelector(el);
  } else if (el && el._isVue) {
    return el.$el;
  } else if (el instanceof HTMLElement) {
    return el;
  } else {
    return null;
  }
}

export default function goTo(_target, _settings) {
  const settings = Object.assign({}, defaults, _settings);
  const container = getContainer(settings.container);

  const startTime = performance.now();
  const targetLocation = getOffset(_target) - settings.offset;
  const startLocation = container.scrollTop;
  if (targetLocation === startLocation) return Promise.resolve(targetLocation);

  const ease =
    typeof settings.easing === "function"
      ? settings.easing
      : easingPatterns[settings.easing];

  if (!ease)
    throw new TypeError(`Easing function "${settings.easing}" not found.`);

  return new Promise(resolve =>
    requestAnimationFrame(function step(currentTime) {
      const timeElapsed = currentTime - startTime;
      const progress = Math.abs(
        settings.duration ? Math.min(timeElapsed / settings.duration, 1) : 1
      );

      container.scrollTop = Math.floor(
        startLocation + (targetLocation - startLocation) * ease(progress)
      );

      if (
        progress === 1 ||
        container.clientHeight + container.scrollTop === container.scrollHeight
      ) {
        return resolve(targetLocation);
      }

      requestAnimationFrame(step);
    })
  );
}
